import React, { Component } from 'react';
import {
	BrowserRouter as Router,
	Route,
	Link
} from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
// import dcLogo from './img/dc-logo-2018-b.svg';
import { DCLogo } from './DCLogo';
import './App.css';
import SiteNav from './SiteNav';
// import Transition from 'react-transition-group/Transition';
import { About } from './About';
import { Portfolio } from './Portfolio';
import { Contact } from './Contact';
import { CoffeeOutside } from './Redirect';
import { SocialLinks } from './SocialLinks';
//import ReactTransitionGroup from 'react-addons-transition-group'; // ES6

class App extends Component {

	constructor(props) {
    super(props);
		this.state = {
			show: false,
			logoCentered: true
		};
    // this.handler = this.handler.bind(this)
    this.handleToggle = this.handleToggle.bind(this);
  }

	handleToggle() {
		console.log( 'Toggle is handled' );
    this.setState(({ show, logoCentered }) => ({
      show: !show,
			logoCentered: !logoCentered
    }))
  }

  render() {
		const appClass = this.state.logoCentered ? 'App logo-centered' : 'App Appno';
		// console.log( this.props );
    return (
		<Router>
			<ScrollToTop>
			<div className={appClass}>
				<SiteNav currentState={this.state} />
				<Route path="/" component={LogoBlock} logoCentered={this.state.logoCentered} onMouseOver={this.handleToggle}/>
				<Route path="/about" component={About}/>
				<Route path="/topics" component={Topics}/>
				<Route path="/portfolio" component={Portfolio}/>
				<Route path="/contact" component={Contact}/>
				<Route path='/coffee_outside' component={CoffeeOutside} />
				<Footer />
			</div>
			</ScrollToTop>
		</Router>
    );
  }
}

class LogoBlock extends Component {
	render(){
		const logoClass = this.props.match.isExact ? ' front-page-active' : '';
		const linkTarget = this.props.match.isExact ? '/about' : '/';

		return (
			<header className={ 'App-header' + logoClass}>
				<Link to={linkTarget} className="App-logo-link">
					<DCLogo />
					{ this.props.match.isExact && <h3 className="tagline">Full-Stack Web Development</h3> }
				</Link>
			</header>
		);
	}
}

// const LogoInline = () => {
// 	return <div>YO<span dangerouslySetInnerHTML={{__html: dcLogo}} /></div>;
// }

// const duration = 300;

// const defaultStyle = {
//   transition: `opacity ${duration}ms ease-in-out`,
//   opacity: 0,
// }

// const transitionStyles = {
//   entering: { opacity: 0 },
//   entered:  { opacity: 1 },
// };

// const Fade = ({ in: inProp }) => (
//   <Transition in={inProp} timeout={duration}>
//     {(state) => (
//       <div style={{
//         ...defaultStyle,
//         ...transitionStyles[state]
//       }} className={`fade fade-${state}`}>
//         Im A fade Transition!
//       </div>
//     )}
//   </Transition>
// );

const Topics = ({ match }) => (
  <div>
    <h2>Topics</h2>
    <ul>
      <li>
        <Link to={`${match.url}/rendering`}>
          Rendering with React
        </Link>
      </li>
      <li>
        <Link to={`${match.url}/components`}>
          Components
        </Link>
      </li>
      <li>
        <Link to={`${match.url}/props-v-state`}>
          Props v. State
        </Link>
      </li>
    </ul>

    <Route path={`${match.url}/:topicId`} component={Topic}/>
    <Route exact path={match.url} render={() => (
      <h3>Please select a topic.</h3>
    )}/>
  </div>
)

const Topic = ({ match }) => (
  <div>
    <h3>{match.params.topicId}</h3>
  </div>
)

const Footer = () => (
	<div className="footer"><SocialLinks /></div>
)

export default App;



// WEBPACK FOOTER //
// ./src/App.js